// AUTO-GENERATED by analysis/cryptic/gen_conditions.py — do not hand-edit.
// Pre-determined 10-puzzle test CONDITIONS (24-game model): 9 fixed groups, each one
// puzzle per difficulty band (decile 0 hardest … 9 easiest). A session is allocated ONE
// whole group at random. Built from 98 puzzles (90 used across 9 groups; 8 leftover stay free-play only).

export const CRYPTIC_CONDITIONS: string[][] = [
  ['cc_095', 'cc_011', 'cc_043', 'cc_053', 'cc_004', 'cc_010', 'cc_098', 'cc_039', 'cc_018', 'cc_055'],
  ['cc_091', 'cc_068', 'cc_049', 'cc_088', 'cc_016', 'cc_054', 'cc_074', 'cc_028', 'cc_026', 'cc_048'],
  ['cc_001', 'cc_097', 'cc_037', 'cc_070', 'cc_085', 'cc_072', 'cc_033', 'cc_002', 'cc_082', 'cc_096'],
  ['cc_034', 'cc_007', 'cc_064', 'cc_027', 'cc_013', 'cc_071', 'cc_084', 'cc_038', 'cc_080', 'cc_056'],
  ['cc_030', 'cc_041', 'cc_017', 'cc_031', 'cc_014', 'cc_009', 'cc_022', 'cc_023', 'cc_040', 'cc_081'],
  ['cc_005', 'cc_032', 'cc_047', 'cc_089', 'cc_021', 'cc_092', 'cc_058', 'cc_006', 'cc_003', 'cc_051'],
  ['cc_045', 'cc_099', 'cc_025', 'cc_029', 'cc_077', 'cc_067', 'cc_087', 'cc_090', 'cc_044', 'cc_079'],
  ['cc_083', 'cc_086', 'cc_036', 'cc_061', 'cc_063', 'cc_073', 'cc_057', 'cc_076', 'cc_015', 'cc_062'],
  ['cc_059', 'cc_100', 'cc_046', 'cc_019', 'cc_012', 'cc_094', 'cc_078', 'cc_093', 'cc_035', 'cc_066'],
]
